import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { AvatarUpload } from "@/components/ui/avatar-upload"
import { useAllGames } from "@/graphql/hooks/useGames"
import { Skeleton } from "@/components/ui/skeleton"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Gamepad2 } from "lucide-react"
import { TournamentType } from "@/graphql"

interface TournamentTypeImagesModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  tournamentType: TournamentType
  tournamentTypeName: string
  onSuccess?: () => void
}

export function TournamentTypeImagesModal({
  open,
  onOpenChange,
  tournamentType,
  tournamentTypeName,
  onSuccess,
}: TournamentTypeImagesModalProps) {
  const { games: allGames, loading, error } = useAllGames()

  // Filtrar juegos activos y ordenar por sortOrder, tomar máximo 4
  const games = allGames
    .filter((game) => game.isActive === 1)
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    .slice(0, 4)

  const imageFields = ["image", "image2", "image3", "image4"] as const
  const imageUrlFields = ["urlImage", "urlImage2", "urlImage3", "urlImage4"] as const

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Gestión de imagenes de Tipos de Torneos - {tournamentTypeName}</DialogTitle>
        </DialogHeader>

        {loading && (
          <div className="space-y-4">
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} className="h-32 w-full" />
            ))}
          </div>
        )}

        {error && (
          <div className="text-center text-destructive p-4">
            Error cargando juegos: {error.message}
          </div>
        )}

        {!loading && !error && (
          <div className="space-y-4">
            {games.map((game, index) => {
              const urlImagePath = imageUrlFields[game.sortOrder - 1]
              const urlImage = tournamentType[urlImagePath]
              return (
                <Card key={game.id}>
                  <CardHeader className="pb-3">
                    <CardTitle className="flex items-center gap-2 text-base">
                      <Gamepad2 className="h-4 w-4" />
                      {game.name}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-2">
                      <p className="text-sm font-medium text-muted-foreground">
                        {imageFields[game.sortOrder - 1].charAt(0).toUpperCase() +
                          imageFields[game.sortOrder - 1].slice(1)}
                        <br />
                        {imageUrlFields[game.sortOrder - 1]}
                      </p>
                      <AvatarUpload
                        type="tournamenttype.image"
                        tournamentTypeId={tournamentType.id}
                        src={urlImage}
                        gameId={game.id}
                        field={imageFields[index]}
                        name={`${tournamentTypeName}-${game.name}`}
                        className="w-full"
                        cb={() => onSuccess?.()}
                      />
                    </div>
                  </CardContent>
                </Card>
              )
            })}
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
